import { styled } from "@mui/material";

import RawBracket from "@public/raw_bracket.svg";

export const StyledBracket = styled(RawBracket)`
  color: white;
  scale: 2;
  filter: drop-shadow(0 0 0.75rem white);
`;

export const StyledPage = styled("div")`
  div {
    border-radius: 1rem;
    overflow: hidden;
    width: 100%;
    height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;

    --color-a: #05df54;
    --color-b: #96c5f0;

    @property --start-color {
      syntax: "<color>";
      inherits: false;
      initial-value: var(--color-a);
    }

    @property --stop-color {
      syntax: "<color>";
      inherits: false;
      initial-value: var(--color-b);
    }

    background-image: linear-gradient(
      45deg,
      var(--start-color),
      var(--stop-color)
    );

    animation: gradient 5s infinite;

    @keyframes gradient {
      0% {
        --start-color: var(--color-a);
        --stop-color: var(--color-b);
      }
      50% {
        --start-color: var(--color-b);
        --stop-color: var(--color-a);
      }
      100% {
        --start-color: var(--color-a);
        --stop-color: var(--color-b);
      }
    }
  }
`;
